/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlType3 } from './ControlType3';
import {
    ControlType3FromJSON,
    ControlType3FromJSONTyped,
    ControlType3ToJSON,
} from './ControlType3';

/**
 * 
 * @export
 * @interface ControlDirectoryUserTypeCount
 */
export interface ControlDirectoryUserTypeCount {
    /**
     * 
     * @type {number}
     * @memberof ControlDirectoryUserTypeCount
     */
    count: number;
    /**
     * 
     * @type {ControlType3}
     * @memberof ControlDirectoryUserTypeCount
     */
    type: ControlType3;
}

/**
 * Check if a given object implements the ControlDirectoryUserTypeCount interface.
 */
export function instanceOfControlDirectoryUserTypeCount(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "count" in value;
    isInstance = isInstance && "type" in value;

    return isInstance;
}

export function ControlDirectoryUserTypeCountFromJSON(json: any): ControlDirectoryUserTypeCount {
    return ControlDirectoryUserTypeCountFromJSONTyped(json, false);
}

export function ControlDirectoryUserTypeCountFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlDirectoryUserTypeCount {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'type': ControlType3FromJSON(json['type']),
    };
}

export function ControlDirectoryUserTypeCountToJSON(value?: ControlDirectoryUserTypeCount | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'type': ControlType3ToJSON(value.type),
    };
}

